import { render, staticRenderFns } from "./EventStamp.vue?vue&type=template&id=1e6d5887&scoped=true&"
import script from "./EventStamp.vue?vue&type=script&lang=js&"
export * from "./EventStamp.vue?vue&type=script&lang=js&"
import style0 from "./EventStamp.vue?vue&type=style&index=0&id=1e6d5887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6d5887",
  null
  
)

export default component.exports